import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "@/context/AuthContext";
import Seo from "@/components/Seo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      navigate(u.role === "admin" ? "/admin" : redirect);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-[#050505] border border-white/10 focus:border-emerald-500 outline-none text-sm text-slate-200 px-4 py-3.5 transition-colors placeholder:text-slate-600";

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <Seo title="Sign In | Dark Growers Genetics" description="Sign in to your Dark Growers Genetics account to view orders and check out." noindex />
      <p className="label-caps text-emerald-500 mb-3 text-center">Members Only</p>
      <h1 className="font-display text-5xl text-slate-100 text-center mb-10">Sign In</h1>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <input type="email" required placeholder="Email" data-testid="login-email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
        <input type="password" required placeholder="Password" data-testid="login-password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />
        {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-emerald-600 text-white hover:bg-emerald-500 disabled:opacity-50 transition-colors font-medium py-3.5 text-sm tracking-wide">
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
      <p className="text-slate-500 text-sm text-center mt-6">
        New here?{" "}
        <Link to="/register" className="text-emerald-400 hover:text-emerald-300">Create an account</Link>
      </p>
    </div>
  );
}
